import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutCRMMultiSelectErrorSlideout extends Layout {
    labelFailed: Label;
    labelFailedCount: Label;
    panelFailed: Panel;
    sourceProspectiveSales: DataSource;
    tableFailed: Table;
}
